module.exports = __webpack_public_path__ + "static/media/Alias.d13138fd.png";